export default __webpack_public_path__ + "alberta-numbered-list.4ddb2ccfd448c81ffccd.svg";